module.exports = __webpack_public_path__ + "img/browser_trash@2x.7e2f8341.png";